export function truncString(str: string, max: number = 13) {
  return str.length > max ? `${str.slice(0, max)}..` : str;
}
